import { initFilters } from 'actions/search';

export function appBoot() {
  return (dispatch, getState) => {
    dispatch(initFilters());
  };
}
